import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { decodeQueryString } from '../queryString'

const CORRELATION_LINKS_CONTAINER_SELECTOR = 'js-quote-correlation-links-container'
const MULTITICKER_CHART_ELEMENT_SELECTOR = 'js-multi-ticker-chart'
const SET_SEARCH_EXT_SELECTOR = 'js-set-search-ext-argument'

export function useStockDetailUpdater() {
  const location = useLocation()
  const { p, ty } = decodeQueryString(location.search)
  const isInitializedRef = React.useRef(false)
  const [isStockDetailUpdating, setIsStockDetailUpdating] = React.useState(false)

  React.useEffect(() => {
    const multiTickerElements = document.getElementsByClassName(MULTITICKER_CHART_ELEMENT_SELECTOR)
    const correlationElements = document.getElementsByClassName(CORRELATION_LINKS_CONTAINER_SELECTOR)
    const abortController = new AbortController()

    if (isInitializedRef.current) {
      if (multiTickerElements.length > 0) setIsStockDetailUpdating(true)

      fetch(location.pathname + location.search, { signal: abortController.signal })
        .then((response) => response.text())
        .then((text) => {
          const virtualDOM = new DOMParser().parseFromString(text, 'text/html')

          // Multiticker update
          if (multiTickerElements.length > 0) {
            const multiTickerHtmlElements = Array.from(multiTickerElements) as HTMLImageElement[]
            const newMultiTickerHtmlElements = Array.from(
              virtualDOM.getElementsByClassName(MULTITICKER_CHART_ELEMENT_SELECTOR)
            ) as HTMLImageElement[]

            if (newMultiTickerHtmlElements?.length === multiTickerHtmlElements.length) {
              multiTickerHtmlElements.forEach((element, index) => {
                element.onload = () => setIsStockDetailUpdating(false)
                element.src = newMultiTickerHtmlElements[index].src
              })
            } else {
              setIsStockDetailUpdating(false)
            }
          }

          // Correlation update
          const correlationLinksTableCellHtmlElements = Array.from(correlationElements) as HTMLTableCellElement[]
          const newCorrelationLinksTableCellHtmlElements = Array.from(
            virtualDOM.getElementsByClassName(CORRELATION_LINKS_CONTAINER_SELECTOR)
          ) as HTMLTableCellElement[]

          if (newCorrelationLinksTableCellHtmlElements?.length === correlationLinksTableCellHtmlElements.length) {
            correlationLinksTableCellHtmlElements.forEach((element, index) => {
              element.innerHTML = newCorrelationLinksTableCellHtmlElements[index].innerHTML
            })
          }

          // Search function update
          const newsearchFunctionWrapperElement = virtualDOM.getElementById(SET_SEARCH_EXT_SELECTOR) as HTMLDivElement
          if (newsearchFunctionWrapperElement?.dataset.setSearchExtArgument) {
            window.SetSearchExt?.(newsearchFunctionWrapperElement.dataset.setSearchExtArgument)
          }
        })
        .catch((err) => {
          setIsStockDetailUpdating(false)
          if (err.name !== 'AbortError') {
            Sentry.captureException(err)
          }
        })
    }
    isInitializedRef.current = true
    return () => {
      abortController.abort()
    }
    // We don't want to trigger effect on any location change just if period or type change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p, ty])

  return { isStockDetailUpdating }
}
